"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsUserTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _DmsFetch = require("../../components/DmsFetch/DmsFetch");
var _DmsPermissions = require("../../components/DmsPermissions/DmsPermissions");
var _DmsTable = require("../../components/DmsTable/DmsTable");
var _DmsTableCreateButton = require("../../components/DmsTableButton/DmsTableCreateButton");
var _DmsFlexContainer = require("../../components/DmsFlexContainer/DmsFlexContainer");
var _Permissions = require("../../constants/Permissions");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsButtonGroup = require("../DmsButtonGroup/DmsButtonGroup");
var _DmsTableEditButton = require("../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../DmsTableButton/DmsTableDeleteButton");
var _DmsTableButton = require("../DmsTableButton/DmsTableButton");
var _Lock = _interopRequireDefault(require("@mui/icons-material/Lock"));
var _UserStatusEnum = require("../../constants/UserStatusEnum");
var _RemoteType = require("../../constants/RemoteType");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DmsUserTable = _ref => {
  let {
    passwordPopup
  } = _ref;
  const table = (0, _react.useRef)(null);
  const [authenticatorPk, setAuthenticatorPk] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const getAuthType = async () => {
      try {
        const response = await (0, _DmsFetch.fetchData)("/login_settings", "GET", true);
        if (response && response.data && response.data.data) {
          setAuthenticatorPk(response.data.data.authenticator_pk);
        }
      } catch (error) {
        console.error("Failed to fetch login settings:", error);
        setAuthenticatorPk(null);
      }
    };
    getAuthType();
  }, []);
  const user_header = [{
    label: _reactIntlUniversal.default.get("Name").d("Name"),
    column_name: "user_name",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Login").d("Login"),
    column_name: "user_login",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Password").d("Password"),
    column_name: "user_password",
    hidden: true,
    can_edit: false,
    control: "password",
    placeholder: "(unchanged)"
  }, {
    label: _reactIntlUniversal.default.get("ConfirmPassword").d("Confirm Password"),
    column_name: "user_password_confirm",
    hidden: true,
    can_edit: false,
    control: "password",
    placeholder: "(unchanged)"
  }, {
    label: _reactIntlUniversal.default.get("Email").d("Email"),
    column_name: "user_email",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Phone").d("Phone"),
    column_name: "user_phone",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Status").d("Status"),
    column_name: "status",
    map: Object.fromEntries(Object.entries(_UserStatusEnum.UserStatusEnum).map(_ref2 => {
      let [key, value] = _ref2;
      return [value, key];
    })),
    can_edit: false,
    can_create: false
  }, {
    label: _reactIntlUniversal.default.get("Roles").d("Roles"),
    column_name: "roles",
    control: "select",
    url: "/role/all",
    properties: {
      label: "role_name",
      value: "role_name",
      column_name: "role_name",
      text_template: "{role_name}",
      multiple: true,
      filter: {
        value: "pk",
        field: "role_pk",
        join: "user_role",
        left: "user_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: true,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    column_name: "actions",
    permissions: [_Permissions.Permissions.CAN_EDIT_USER],
    hidden: authenticatorPk === _RemoteType.REMOTE_AUTHENTICATOR_TYPE.LDAP_AUTH,
    width: "4.17vw",
    sortable: false,
    element: row => {
      const user_name = row.user_name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Updateuser_name", {
          user_name
        }).d("Update {user_name}"),
        url: "/user/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Deleteuser_name", {
          user_name
        }).d("Delete {user_name}"),
        text: _reactIntlUniversal.default.get("DmsPageUser.deleteButton.text", {
          user_name
        }).d("The user with login {user_name} will be deleted. Are you sure?"),
        url: "/user/",
        row_pk: row.pk
      }), /*#__PURE__*/_react.default.createElement(_DmsTableButton.DmsTableButton, {
        table: table,
        variant: "warning",
        icon: /*#__PURE__*/_react.default.createElement(_Lock.default, null),
        onClick: () => passwordPopup(row)
      }));
    }
  }];
  const createUser = async data => {
    const url = "/user";
    const response = await (0, _DmsFetch.fetchData)(url, "POST", true, data);
    if (response.status === _HttpStatus.HTTP_STATUS.CREATED_201) {
      table.current.updateTable();
      _sweetalert.default.fire({
        icon: "success",
        title: _reactIntlUniversal.default.get("Success").d("Success"),
        text: _reactIntlUniversal.default.get("UserCreated").d("User Created")
      });
    } else {
      var _response$data;
      _sweetalert.default.fire({
        icon: "error",
        title: _reactIntlUniversal.default.get("Error").d("Error"),
        text: response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.detail
      });
    }
  };
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_USER
  }, /*#__PURE__*/_react.default.createElement(_DmsTableCreateButton.DmsTableCreateButton, {
    header: user_header,
    table: table,
    handler: createUser,
    title: _reactIntlUniversal.default.get("Createuser").d("Create user")
  }))));
  return /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    header: user_header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/user/table",
    export_table: false,
    toolbar: toolbar,
    responsive: true
  });
};
exports.DmsUserTable = DmsUserTable;